<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Upside down text</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="flip()">Flip</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    flip() {
      let text = this.text.toLowerCase()
      let last = text.length - 1
      let result = ''
      for (let i = last; i >= 0; --i) {
        result += this.flipChar(text.charAt(i))
      }
      this.result = result
    },
    flipChar(c) {
      if (c == 'a') {
        return '\u0250'
      } else if (c == 'b') {
        return 'q'
      } else if (c == 'c') {
        return '\u0254'
      } else if (c == 'd') {
        return 'p'
      } else if (c == 'e') {
        return '\u01DD'
      } else if (c == 'f') {
        return '\u025F'
      } else if (c == 'g') {
        return 'b'
      } else if (c == 'h') {
        return '\u0265'
      } else if (c == 'i') {
        return '\u0131' //'u0131u0323'
      } else if (c == 'j') {
        return '\u0638'
      } else if (c == 'k') {
        return '\u029E'
      } else if (c == 'l') {
        return '\u05DF'
      } else if (c == 'm') {
        return '\u026F'
      } else if (c == 'n') {
        return 'u'
      } else if (c == 'o') {
        return 'o'
      } else if (c == 'p') {
        return 'd'
      } else if (c == 'q') {
        return 'b'
      } else if (c == 'r') {
        return '\u0279'
      } else if (c == 's') {
        return 's'
      } else if (c == 't') {
        return '\u0287'
      } else if (c == 'u') {
        return 'n'
      } else if (c == 'v') {
        return '\u028C'
      } else if (c == 'w') {
        return '\u028D'
      } else if (c == 'x') {
        return 'x'
      } else if (c == 'y') {
        return '\u028E'
      } else if (c == 'z') {
        return 'z'
      } else if (c == '[') {
        return ']'
      } else if (c == ']') {
        return '['
      } else if (c == '(') {
        return ')'
      } else if (c == ')') {
        return '('
      } else if (c == '{') {
        return '}'
      } else if (c == '}') {
        return '{'
      } else if (c == '?') {
        return '\u00BF'
      } else if (c == '\u00BF') {
        return '?'
      } else if (c == '!') {
        return '\u00A1'
      } else if (c == "'") {
        return ','
      } else if (c == ',') {
        return "'"
      } else if (c == '.') {
        return '\u02D9'
      } else if (c == '_') {
        return '\u203E'
      } else if (c == ';') {
        return '\u061B'
      } else if (c == '9') {
        return '6'
      } else if (c == '6') {
        return '9'
      }
      return c
    }
  }
}
</script>

<style>
</style>